module.exports = __webpack_public_path__ + "img/草果.cd772591.jpg";